import { SearchTerm } from "./SearchTerm";

const ZoneSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "zoneName",
        translationKey: "name"
    },
    {
        heading: "Controller",
        accessor: "controller",
        searchOnName: "controller.deviceImprox.devName",
        translationKey: "controller"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "controller.site.siteName",
        translationKey: "site"
    },
];

export default ZoneSearch;
